import kiteLogin from '@assets/images/brokers/kite-logo.png';
import alice from '@assets/images/brokers/alice.webp';
import angelOne from '@assets/images/brokers/angel_booking.webp';
import fyers from '@assets/images/brokers/Logo-fyers-final.webp';
import upstox from '@assets/images/brokers/upstock.webp';
import icici from '@assets/images/brokers/icic.webp';
import fivePaisa from '@assets/images/brokers/5paisa.webp';
import dhan from '@assets/images/brokers/dhan.jpg';
import flatTrade from '@assets/images/brokers/flattrade.jpg';
import shoonya from '@assets/images/brokers/shoonya-logo.png';
import xts from '@assets/images/brokers/xts.png';
import kotakNeo from '@assets/images/brokers/kotakneo.png';
import firstock from '@assets/images/brokers/firstock.png';
import zebu from '@assets/images/brokers/zebu.svg';
import jainamXTS from '@assets/images/brokers/jainam.webp';
import fnotraderLogo from '@assets/images/brokers/fnotrader-logo.png';

export const BROKER_SLUGS = {
  ZERODHA: 'zerodha',
  ALICEBLUE: 'aliceblue',
  FYERS: 'fyers',
  ICICI: 'icici',
  ANGELONE: 'angelone',
  FIVEPAISA: '5paisa',
  UPSTOX: 'upstox',
  DHAN: 'dhan',
  FLATTRADE: 'flattrade',
  SHOONYA: 'shoonya',
  XTS_RETAIL: 'xtsRetail',
  PAPERTRADING: 'papertrading',
  XTS_PROP: 'xtsProp',
  KOTAKNEO: 'kotakneo',
  FIRSTOCK: 'firstock',
  ZEBU: 'zebu',
};

export const BROKER_LOGOS = {
  [BROKER_SLUGS.ZERODHA]: kiteLogin,
  [BROKER_SLUGS.ALICEBLUE]: alice,
  [BROKER_SLUGS.FYERS]: fyers,
  [BROKER_SLUGS.ICICI]: icici,
  [BROKER_SLUGS.UPSTOX]: upstox,
  [BROKER_SLUGS.FIVEPAISA]: fivePaisa,
  [BROKER_SLUGS.ANGELONE]: angelOne,
  [BROKER_SLUGS.DHAN]: dhan,
  [BROKER_SLUGS.FLATTRADE]: flatTrade,
  [BROKER_SLUGS.SHOONYA]: shoonya,
  [BROKER_SLUGS.XTS_RETAIL]: xts,
  [BROKER_SLUGS.KOTAKNEO]: kotakNeo,
  [BROKER_SLUGS.FIRSTOCK]: firstock,
  [BROKER_SLUGS.PAPERTRADING]: fnotraderLogo,
  [BROKER_SLUGS.XTS_PROP]: jainamXTS,
  [BROKER_SLUGS.ZEBU]: zebu,
  xts: xts, // fallback for API data
  papertrading: fnotraderLogo,
  jainam: jainamXTS,
};

const LOGIN_TYPE_NAMES = {
  [BROKER_SLUGS.ZERODHA]: 'Zerodha',
  [BROKER_SLUGS.ALICEBLUE]: 'Aliceblue',
  [BROKER_SLUGS.FYERS]: 'Fyers',
  [BROKER_SLUGS.ICICI]: 'ICICI Direct',
  [BROKER_SLUGS.ANGELONE]: 'Angel One',
  [BROKER_SLUGS.FIVEPAISA]: '5Paisa',
  [BROKER_SLUGS.UPSTOX]: 'Upstox',
  [BROKER_SLUGS.DHAN]: 'Dhan',
  [BROKER_SLUGS.FLATTRADE]: 'FlatTrade',
  [BROKER_SLUGS.SHOONYA]: 'Shoonya',
  [BROKER_SLUGS.XTS_RETAIL]: 'XTS',
  [BROKER_SLUGS.PAPERTRADING]: 'Paper Trading',
  [BROKER_SLUGS.XTS_PROP]: 'Jainam (XTS)',
  [BROKER_SLUGS.KOTAKNEO]: 'Kotak Neo',
  [BROKER_SLUGS.FIRSTOCK]: 'Firstock',
  [BROKER_SLUGS.ZEBU]: 'Zebu',
};

export const getBrokerDisplayName = (slug) => LOGIN_TYPE_NAMES[slug] ?? slug;

const STORAGE_KEY_MAP = {
  [BROKER_SLUGS.ZERODHA]: 'Zerodha',
  [BROKER_SLUGS.ALICEBLUE]: 'Aliceblue',
  [BROKER_SLUGS.FYERS]: 'Fyers',
  [BROKER_SLUGS.ICICI]: 'ICICI',
  [BROKER_SLUGS.ANGELONE]: 'AngelOne',
  [BROKER_SLUGS.FIVEPAISA]: 'fivePaisa',
  [BROKER_SLUGS.UPSTOX]: 'upstox',
  [BROKER_SLUGS.DHAN]: 'dhan',
  [BROKER_SLUGS.FLATTRADE]: 'flattrade',
  [BROKER_SLUGS.SHOONYA]: 'shoonya',
  [BROKER_SLUGS.XTS_RETAIL]: 'xts',
  [BROKER_SLUGS.PAPERTRADING]: 'paperbroker',
  [BROKER_SLUGS.XTS_PROP]: 'jainamxts',
  [BROKER_SLUGS.KOTAKNEO]: 'kotakneo',
  [BROKER_SLUGS.FIRSTOCK]: 'firstock',
  [BROKER_SLUGS.ZEBU]: 'zebu',
};

export const getStorageKeyFromSlug = (slug) => STORAGE_KEY_MAP[slug] ?? slug;

export const getLogoFromSlug = (slug) => BROKER_LOGOS[slug] ?? null;

export const SETUP_REQUIRED_SLUGS = [
  BROKER_SLUGS.ZERODHA,
  BROKER_SLUGS.ALICEBLUE,
  BROKER_SLUGS.FYERS,
  BROKER_SLUGS.ICICI,
  BROKER_SLUGS.ANGELONE,
  BROKER_SLUGS.FIVEPAISA,
  BROKER_SLUGS.UPSTOX,
  BROKER_SLUGS.DHAN,
  BROKER_SLUGS.FLATTRADE,
  BROKER_SLUGS.SHOONYA,
  BROKER_SLUGS.XTS_RETAIL,
  BROKER_SLUGS.XTS_PROP,
  BROKER_SLUGS.KOTAKNEO,
  BROKER_SLUGS.FIRSTOCK,
  BROKER_SLUGS.ZEBU,
];

export const CREDENTIAL_LOGIN_TYPES = new Set([
  BROKER_SLUGS.SHOONYA,
  'xts',
  BROKER_SLUGS.KOTAKNEO,
  BROKER_SLUGS.ANGELONE,
  BROKER_SLUGS.FIRSTOCK,
]);

export const getStatusMeta = (status) => {
  const s = (status || '').toLowerCase();
  if (s === 'loggedin') return { color: '#198754', text: 'Active' };
  if (s === 'loggedout') return { color: '#fd7e14', text: 'Logged out' };
  if (s === 'submitted') return { color: '#0dcaf0', text: 'Pending' };
  if (s === 'error') return { color: '#dc3545', text: 'Error' };
  return { color: '#6c757d', text: status || 'Unknown' };
};
